import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import Layout from '../../components/Layout'
import OrderCard from '../../components/OrderCard'
import Spinner from '../../components/Spinner'
import { getOrders } from '../../api/orders'
import { useAuth } from '../../context/AuthContext'
import { useT } from '../../i18n'

export default function AdminOrdersPage() {
  const { user } = useAuth()
  const lang = user?.language ?? 'ru'
  const tr = useT(lang)
  const [searchParams] = useSearchParams()
  const [status, setStatus] = useState(searchParams.get('status') ?? '')

  const STATUSES = [
    { value: '',          label: tr('all') },
    { value: 'reviewing', label: tr('tabReviewing') },
    { value: 'approved',  label: tr('tabApproved') },
    { value: 'active',    label: tr('tabActive') },
    { value: 'closed',    label: tr('tabClosed') },
    { value: 'rejected',  label: tr('tabRejected') },
  ]

  const { data, isLoading } = useQuery({
    queryKey: ['admin-orders', status],
    queryFn: () => getOrders({ status: status || undefined, limit: 100 }),
    placeholderData: (prev) => prev,
  })

  return (
    <Layout title={tr('orders')}>
      <div style={{ display: 'flex', gap: 6, overflowX: 'auto', marginBottom: 20, paddingBottom: 2 }}>
        {STATUSES.map((s) => {
          const isActive = status === s.value
          return (
            <button
              key={s.value}
              onClick={() => setStatus(s.value)}
              style={{
                padding: '7px 13px', borderRadius: 99, whiteSpace: 'nowrap',
                fontFamily: '"Instrument Sans", sans-serif', fontSize: 12, fontWeight: 500,
                background: isActive ? '#F5F4F0' : 'transparent',
                color: isActive ? '#0A0A0B' : '#A8A8AE',
                border: isActive ? 'none' : '1px solid rgba(255,255,255,0.10)',
              }}
            >
              {s.label}
            </button>
          )
        })}
      </div>

      {isLoading ? (
        <Spinner className="mt-10" />
      ) : !data?.items.length ? (
        <p style={{ textAlign: 'center', color: '#8A8A96', marginTop: 40, fontSize: 14 }}>{tr('noOrders')}</p>
      ) : (
        <div className="flex flex-col gap-3">
          {data.items.map((o) => <OrderCard key={o.id} order={o} adminMode />)}
        </div>
      )}
    </Layout>
  )
}
